define('casino/tournaments',['jquery', 'casino/casino-data', 'all/dialog', 'all/interval-manager', 'all/template', 'casino/populate'], function($, casinoData, dialog, IntervalManager) {
    'use strict';
    var tournaments = {};

    var tournamentLeaderboardRowTemplate =
            '<tr class="{{#currentPlayer}}marked{{/currentPlayer}}" data-qualified="{{qualified}}">' +
            '<td>#{{position}}</td>' +
            '<td><span class="flag {{country}}_small"></span>{{name}}</td>' +
            '<td>{{score}}</td>' +
            '</tr>';

    function populateGames($target) {
        $target.find('[data-games]').each(function() {
            var $this = $(this);
            $this.populate($this.data('games'), {gamesPerPage: 8});
            $this.scroller({direction: 'left', auto: false});
        });
    }

    function initializeOngoingLeaderboard($tournaments) {
        $tournaments.find('a[data-tab]').click(function(event) {
            event.preventDefault();
            var tab = $(this).data('tab');
            var $section = $(this).parentsUntil('.cnt-list-box').parent().first();
            if (!$section.is('.' + tab)) {
                $section.removeClass('leaderboard info').addClass(tab);
                $section.find('table').toggle();
                var $selectedListItem = $section.find('nav a[data-tab=' + tab + ']').parent();
                $selectedListItem.addClass('active');
                $selectedListItem.siblings().removeClass('active');
            }
        });
        $tournaments.find('input[type=checkbox]').click(function() {
            var checked = $(this).is(':checked');
            $(this).parentsUntil('table').find('[data-qualified]').each(function() {
                var $this = $(this);
                if (!checked) {
                    $this.show();
                } else {
                    if ($this.data('qualified')) {
                        $this.show();
                    } else {
                        $this.hide();
                    }
                }
            });
        });
    }

    function initializeNavigationButtons($tournaments) {
        $tournaments.find('.cnt-page-header').find('a').click(function(event) {
            event.preventDefault();
            scrollTo(0, $('#tournament-schedule').offset().top);
        });
    }

    function updateTournamentTime() {
        var minuteInMilliseconds = 60 * 1000;
        var hourInMilliseconds = 60 * minuteInMilliseconds;
        var now = new Date().getTime();
        $('span[data-tournament-updating-time]').each(function() {
            var data = {
                hours: 0,
                minutes: 0
            };
            var date = new Date($(this).data('tournamentUpdatingTime'));
            var delta = date.getTime() - now;
            if (delta > 0) {
                data.hours = Math.floor(delta / hourInMilliseconds);
                delta -= data.hours * hourInMilliseconds;
                data.minutes = Math.ceil(delta / minuteInMilliseconds);
            }
            var template;
            if (data.hours > 23) {
                template = 'date';
            } else if (data.hours > 0) {
                template = 'hours-and-minutes';
            } else if (data.minutes > 0) {
                template = 'minutes';
            } else {
                if ($(this).find('template[data-name="ended"]').length !== 0) {
                    template = 'ended';
                } else {
                    template = 'minutes';
                }
            }
            $(this).applyTemplate(data, {template: template, date: date});
        });
    }

    function updateFixedTournamentTime() {
        $('span[data-tournament-fixed-time]').each(function() {
            var $this = $(this);
            var timestamp = $this.data('tournamentFixedTime');
            $this.applyTemplate(undefined, {date: new Date(timestamp)});
        });
    }

    function initializeTimeSpans() {
        updateTournamentTime();
        setInterval(updateTournamentTime, 10000);
        updateFixedTournamentTime();
    }

    function initializeInGame() {
        $('#tournament-info').find('a').click(function() {
            var $tournamentBar = $('#ingame-tournament-bar');
            if ($tournamentBar.is(':visible')) {
                $(this).removeClass('active');
            } else {
                $(this).addClass('active');
            }
            $tournamentBar.slideToggle('fast');
        });
    }

    function initializePopupLinks() {
        $('#tournament-schedule,#ingame-tournament-bar,#tournaments').find('a[data-occurrence-id]').click(function(event) {
            event.preventDefault();
            dialog.load('tournaments',
                    {occurrenceId: $(this).data('occurrenceId')},
            function() {
                var $this = $(this);
                populateGames($this);
                initializeOngoingLeaderboard($this);
                updateTournamentTime();
                updateFixedTournamentTime();
            }
            );
        });
    }

    function leaderboardRefresher($tournaments) {
        $.ajax({
            dataType: 'json',
            url: '/pp?flow=GetTournamentLeaderboards',
            cache: false
        }).success(function(leaderboards) {
            $.each(leaderboards, function(occurrenceId, leaderboard) {
                if (leaderboard && leaderboard.length > 0) {
                    $tournaments.find('table[data-occurrence-id="' + occurrenceId + '"]').each(function() {
                        var $tableBody = $(this).find('tbody');
                        var $qualifiedPlayerFilterCheckbox = $tableBody.children().last();
                        $tableBody.applyTemplate(leaderboard, {into: $tableBody, templateHtml: tournamentLeaderboardRowTemplate});
                        $tableBody.append($qualifiedPlayerFilterCheckbox);
                    });
                    /*
                     * Refresh the function that filters the leaderboards
                     */
                    $tournaments.find('input[type=checkbox]').click(function() {
                        var checked = $(this).is(':checked');
                        $(this).parentsUntil('table').find('[data-qualified]').each(function() {
                            var $this = $(this);
                            if (!checked) {
                                $this.show();
                            } else {
                                if ($this.data('qualified')) {
                                    $this.show();
                                } else {
                                    $this.hide();
                                }
                            }
                        });
                    });
                    var positionToShow = leaderboard[0];
                    for (var i = 0; i < leaderboard.length; i++) {
                        if (leaderboard[i].currentPlayer) {
                            positionToShow = leaderboard[i];
                            break;
                        }
                    }
                    $('#ingame-tournament-bar').find('dl.leaderboard[data-occurrence-id="' + occurrenceId + '"]').applyTemplate(positionToShow);
                }
            });
        });
    }

    var leaderboardRefreshInterval;
    var twoMinutes = 2 * 60 * 1000;
    var tenMinutes = 10 * 60 * 1000;
    var fiveSeconds = 10000;
    var currentInterval = -1;

    function setLeaderboardRefreshInterval(interval) {
        if (currentInterval !== interval) {
            currentInterval = interval;
            IntervalManager.clearInterval(leaderboardRefreshInterval);
            leaderboardRefreshInterval = IntervalManager.setInterval(function() {
                leaderboardRefresher($('#casino-tournaments'));
            }, interval);
        }
    }

    function initializeTournamentTab() {
        var $tournaments = $('#casino-tournaments');
        initializeNavigationButtons($tournaments);
        initializeOngoingLeaderboard($tournaments);
        populateGames($tournaments);
    }

    function hideIngameTournaments() {
        $('#ingame-tournament-bar').hide();
        var $tournamentInfo = $('#tournament-info');
        $tournamentInfo.hide();
        $tournamentInfo.next('.separator').hide();
        tournaments.normalLeaderboardUpdate();
    }

    function stillRunning($tournamentRow) {
        var hasEnded = false;
        var now = new Date().getTime();
        $tournamentRow.find('[data-tournament-updating-time]').each(function() {
            var endsAt = $(this).data('tournamentUpdatingTime');
            hasEnded = now > endsAt;
        });
        return !hasEnded;
    }

    function toggleVisibleTournaments(gameIds) {
        var tournamentsList = [];
        for (var i = 0; i < gameIds.length; i++) {
            var id = gameIds[i];

            var tournamentsForThisGame = casinoData.gamesInTournaments[id];
            if (!tournamentsForThisGame) {
                continue;
            }
            tournamentsList = tournamentsList.concat(tournamentsForThisGame);
        }

        if (tournamentsList.length > 0) {
            var $tournamentBar = $('#ingame-tournament-bar');
            $tournamentBar.show();
            var visibleTournaments = 0;
            $tournamentBar.find('tr[data-occurrence-id]').each(function() {
                var $this = $(this);
                var gameIsInATournament = $.inArray($this.data('occurrenceId'), tournamentsList) !== -1;
                if (gameIsInATournament && stillRunning($this)) {
                    visibleTournaments++;
                    $this.show();
                } else {
                    $this.hide();
                }
            });
            if (visibleTournaments === 0) {
                hideIngameTournaments();
            } else {
                var $tournamentInfo = $('#tournament-info');
                $tournamentInfo.show();
                $tournamentInfo.next('.separator').show();
                tournaments.fastLeaderboardUpdate();
            }
        } else {
            hideIngameTournaments();
        }
    }

    $(function() {
		initializeTournamentTab();
        initializeTimeSpans();
        initializeInGame();
        initializePopupLinks();
        setLeaderboardRefreshInterval(twoMinutes);
    });

    tournaments.fastLeaderboardUpdate = function() {
        setLeaderboardRefreshInterval(fiveSeconds);
    };
    tournaments.normalLeaderboardUpdate = function() {
        setLeaderboardRefreshInterval(twoMinutes);
    };
    tournaments.toggleVisibleTournaments = toggleVisibleTournaments;
    tournaments.hideIngameTournaments = hideIngameTournaments;

    return tournaments;
});

